/** Gera slug estável para filtros (mesma regra do modal Filtros global). */
export function nameToFilterSlug(name) {
  return String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export const FILTER_NAME_REGEX = /^[\p{L}0-9]+(?: [\p{L}0-9]+){0,2}$/u;
